import { CheckCircleIcon } from "@heroicons/react/outline";
import Logo from "../../../components/Logo";

const benefits = [
	{
		name: "Register for Life with Cancer classes"
	},
	{
		name: "Recommendations of new classes"
	},
	{
		name: "Join online and in-person classes and events"
	}
];

const ProfileInfoSidebar = () => (
	<>
		<Logo className="mb-4" />


		<p>
			Your Life with Cancer Account is at no cost and gives you access to all of the following:
		</p>

		<div className="p-2 fs-16">
			{
				benefits.map((benefit) => (
					<p key={benefit.name}>
						<CheckCircleIcon className="i i-2x me-2 text-warning" />
						{benefit.name}
					</p>
				))
			}
		</div>
	</>
);

export default ProfileInfoSidebar;
